// src/pages/legal/CGV.js
import React from 'react';
import { Link } from 'react-router-dom';

const CGV = () => {
  return (
    <div className="container-custom py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Conditions Générales de Vente</h1>
        <p className="text-gray-500 mb-8">Dernière mise à jour : 15 Juin 2024</p>
        
        <div className="bg-white rounded-xl shadow-md p-6 space-y-6">
          <section>
            <h2 className="text-xl font-bold mb-3">Article 1 - Prix et commande</h2>
            <p className="text-gray-600">Les prix de nos produits sont indiqués en euros toutes taxes comprises (TTC), hors frais de livraison. Nous nous réservons le droit de modifier nos prix à tout moment. En cas de commande passée avant une modification de prix, le prix applicable est celui en vigueur au moment de la commande.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Article 2 - Commande minimum</h2>
            <p className="text-gray-600">Toute commande doit comporter un minimum de 4 packs pour être validée. Cette condition permet d'optimiser nos tournées de livraison et de garantir un service de qualité.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Article 3 - Livraison</h2>
            <p className="text-gray-600">Les livraisons sont effectuées dans le département du Haut-Rhin (68), dans une zone d'environ 20 km autour de Mulhouse. Les frais de livraison sont calculés selon le nombre de packs commandés. Le délai de livraison est de 48h à 72h ou selon le créneau choisi.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Article 4 - Paiement</h2>
            <p className="text-gray-600">Le paiement s'effectue en ligne par carte bancaire (Visa, Mastercard) via notre prestataire sécurisé Stripe, ou à la livraison en espèces ou carte bancaire auprès du livreur. Le paiement est exigible immédiatement à la commande pour les paiements en ligne, ou à la livraison pour les paiements au livreur.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Article 5 - Rétractation</h2>
            <p className="text-gray-600">Conformément à la loi, vous disposez d'un délai de rétractation de 14 jours à compter de la réception de votre commande pour les produits non ouverts et en parfait état. Les frais de retour sont à votre charge.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Article 6 - Droit applicable</h2>
            <p className="text-gray-600">Les présentes CGV sont soumises au droit français. Tout litige relèvera de la compétence exclusive des tribunaux français.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CGV;